export default __webpack_public_path__ + "static/media/risk-level-5.40abb06e.svg";